<script setup lang="ts">
import type { AgentOnList, AgentOnPreview } from '@@/shared/agent/types';

defineProps<{
  agent: AgentOnList | AgentOnPreview
}>();
</script>

<template>
  <figure class="flex gap-xs items-center">
    <AgentAvatarBubble :agent />
    <figcaption
      class="font-semibold leading-tight"
      v-text="agent.fullName"
    />
  </figure>
</template>
